// extracted by css-extract-rspack-plugin
export default {"root":"TS1mA","selected":"E6OD4"};